import { FormControl } from '@angular/forms';
import { CommonService } from '../service/common.service';
import { CaseItemDto } from '../webservice/caseitem';
import { ItemRenew } from './item-renew';

export class ItemLimitTimeRec {
  public startDateFdForm: FormControl = new FormControl("");
  public finishDateFdForm: FormControl = new FormControl("");
  public minZaiCurrentFvForm: FormControl = new FormControl("");
  public maxZaiCurrentFvForm: FormControl = new FormControl("");
  public minStockDaysCurrentFvForm: FormControl = new FormControl("");
  public maxStockDaysCurrentFvForm: FormControl = new FormControl("");

  NO: number = 0;
  storeCdFv: string = "";
  storeNameFv?: string = "";
  itemCdFv: string = "";
  itemNameFv: string = "";
  standardFv: string = "";
  convFactFv: string = "";
  ctgCd0Fv: string = "";
  ctgName0Fv: string = "";
  ctgCd1Fv: string = "";
  ctgName1Fv: string = "";
  ctgCd2Fv: string = "";
  ctgName2Fv: string = "";
  ctgCd3Fv: string = "";
  ctgName3Fv: string = "";
  suppNameFv: string = "";
  orderableDateFv: string = "";
  orderLotFn: number = 0;
  itemCostPriceFn: number = 0;
  itemSalesPriceFn: number = 0;
  orderStopFlagFn: number = 0;
  orderStopFlagModFn: number = 0;
  orderStopFlagVersionFn: number = 0;
  orderDate: string = "";
  deliveryDate: string = "";
  orderNumFn: number = 0;
  orderNumModFn: number = 0;
  orderNumVersionFn: number = 0;
  orderBaraNumFn: number = 0;
  orderBacklog: number = 0;
  stockNumFn: number = 0;
  stockNumModFn: number = 0;
  stockNumVersionFn: number = 0;
  rankFv: string = "";
  itemClass: string = "";
  itemLocation: string = "";
  orderPointFn: number = 0;
  orderPointSubFn: number = 0;
  adqNumFn: number = 0;
  salesResult1: number = 0;
  salesResult2: number = 0;
  salesResult3: number = 0;
  salesResult4: number = 0;
  orderResult1: number = 0;
  orderResult2: number = 0;
  orderResult3: number = 0;
  orderResult4: number = 0;
  startDateFd: string = "";
  finishDateFd: string = "";
  minZaiIsNull: boolean;
  minZaiFn: string = "";
  minZaiModIsNull: boolean;
  minZaiModFn: number = 0;
  minZaiVersionFn: number = 0;
  maxZaiIsNull: boolean;
  maxZaiFn: string = "";
  maxZaiModIsNull: boolean;
  maxZaiModFn: number = 0;
  maxZaiVersionFn: number = 0;
  minStockDaysIsNull: boolean;
  minStockDaysFn: string = "";
  minStockDaysModIsNull: boolean;
  minStockDaysModFn: number = 0;
  minStockDaysVersionFn: number = 0;
  maxStockDaysIsNull: boolean;
  maxStockDaysFn: string = "";
  maxStockDaysModIsNull: boolean;
  maxStockDaysModFn: number = 0;
  maxStockDaysVersionFn: number = 0;
  ctg0Fv: string = "";
  ctg1Fv: string = "";
  ctg2Fv: string = "";
  ctg3Fv: string = "";
  orderNumCurrentFn: number = 0;
  orderNumCurrentFnUpdated: boolean;
  stockNumCurrentFn: number = 0;
  stockNumCurrentFnUpdated: boolean;
  minZaiCurrentFv: string = "";
  minZaiCurrentFvUpdated: boolean;
  minZaiCurrentIsNull: boolean;
  maxZaiCurrentFv: string = "";
  maxZaiCurrentFvUpdated: boolean;
  maxZaiCurrentIsNull: boolean;
  minStockDaysCurrentFv: string = "";
  minStockDaysCurrentFvUpdated: boolean;
  minStockDaysCurrentIsNull: boolean;
  maxStockDaysCurrentFv: string = "";
  maxStockDaysCurrentFvUpdated: boolean;
  maxStockDaysCurrentIsNull: boolean;
  orderStopFlagCurrentFn: number = 0;
  orderStopFlagCurrentFnUpdated: boolean;
  orderStopFlagCurrentFvUpdated: boolean;
  orderStopFlagCurrentFv: string = "";
  orderBaraNumCurrentFn: number = 0;
  autoOrderLotModFn?: number = 0;
  autoOrderLotFn?: number = 0;
  autoOrderLotModVersionFn?: number = 0;
  autoOrderLotModCurrentFv?: string = "";
  closingTime: number = 0;
  isDisable: boolean = false;

  public minZaiCtg: number = 0;
  public maxZaiCtg: number = 0;
  public minStockDaysCtg: number = 0;
  public maxStockDaysCtg: number = 0;

  public minZaiTimeLimit: number = 0;
  public maxZaiTimeLimit: number = 0;
  public minStockDaysTimeLimit: number = 0;
  public maxStockDaysTimeLimit: number = 0;

  public minZaiTimeLimitUpdated: boolean = false;
  public maxZaiTimeLimitUpdated: boolean = false;
  public minStockDaysTimeLimitUpdated: boolean = false;
  public maxStockDaysTimeLimitUpdated: boolean = false;

  public caseItems: CaseItemDto[];
  public fromItems: ItemRenew[];
  public toItems: ItemRenew[];

  originDto: any;

  constructor(private itemDto: any, private commonService: CommonService) {
    for (var key of Object.keys(itemDto)) {
      this[key] = itemDto[key];
    }
    this.ctg0Fv = this.ctgCd0Fv + ":" + this.ctgName0Fv;
    this.ctg1Fv = this.ctgCd1Fv + ":" + this.ctgName1Fv;
    this.ctg2Fv = this.ctgCd2Fv + ":" + this.ctgName2Fv;
    this.ctg3Fv = this.ctgCd3Fv + ":" + this.ctgName3Fv;
    if (this.orderNumVersionFn > 0) {
      this.orderNumCurrentFn = this.orderNumModFn;
      this.orderNumCurrentFnUpdated = true;
    } else {
      this.orderNumCurrentFn = this.orderNumFn;
      this.orderNumCurrentFnUpdated = false;
    }
    if (this.stockNumVersionFn > 0) {
      this.stockNumCurrentFn = this.stockNumModFn;
      this.stockNumCurrentFnUpdated = true;
    } else {
      this.stockNumCurrentFn = this.stockNumFn;
      this.stockNumCurrentFnUpdated = false;
    }

    if (this.minZaiFn == "") {
      this.minZaiIsNull = true;
    }
    if (this.minZaiModFn == 0) {
      this.minZaiModIsNull = true;
    }
    if (this.minZaiVersionFn > 0) {
      this.minZaiCurrentFv = this.paramCurrent(this.minZaiModFn);
      this.minZaiCurrentFvUpdated = true;
      this.minZaiCurrentIsNull = this.minZaiModIsNull;
    } else {
      this.minZaiCurrentFv = this.paramCurrent(this.minZaiFn);
      this.minZaiCurrentFvUpdated = false;
      this.minZaiCurrentIsNull = this.minZaiIsNull;
    }

    if (this.maxZaiFn == "") {
      this.maxZaiIsNull = true;
    }
    if (this.maxZaiModFn == 0) {
      this.maxZaiModIsNull = true;
    }
    if (this.maxZaiVersionFn > 0) {
      this.maxZaiCurrentFv = this.paramCurrent(this.maxZaiModFn);
      this.maxZaiCurrentFvUpdated = true;
      this.maxZaiCurrentIsNull = this.maxZaiModIsNull;
    } else {
      this.maxZaiCurrentFv = this.paramCurrent(this.maxZaiFn);
      this.maxZaiCurrentFvUpdated = false;
      this.maxZaiCurrentIsNull = this.maxZaiIsNull;
    }

    if (this.minStockDaysFn == "") {
      this.minStockDaysIsNull = true;
    }
    if (this.minStockDaysModFn == 0) {
      this.minStockDaysModIsNull = true;
    }
    if (this.minStockDaysVersionFn > 0) {
      this.minStockDaysCurrentFv = this.paramCurrent(this.minStockDaysModFn);
      this.minStockDaysCurrentFvUpdated = true;
      this.minStockDaysCurrentIsNull = this.minStockDaysModIsNull;
    } else {
      this.minStockDaysCurrentFv = this.paramCurrent(this.minStockDaysFn);
      this.minStockDaysCurrentFvUpdated = false;
      this.minStockDaysCurrentIsNull = this.minStockDaysIsNull;
    }

    if (this.maxStockDaysFn == "") {
      this.maxStockDaysIsNull = true;
    }
    if (this.maxStockDaysModFn == 0) {
      this.maxStockDaysModIsNull = true;
    }
    if (this.maxStockDaysVersionFn > 0) {
      this.maxStockDaysCurrentFv = this.paramCurrent(this.maxStockDaysModFn);
      this.maxStockDaysCurrentFvUpdated = true;
      this.maxStockDaysCurrentIsNull = this.maxStockDaysModIsNull;
    } else {
      this.maxStockDaysCurrentFv = this.paramCurrent(this.maxStockDaysFn);
      this.maxStockDaysCurrentFvUpdated = false;
      this.maxStockDaysCurrentIsNull = this.maxStockDaysIsNull;
    }

    if (this.orderStopFlagVersionFn > 0) {
      this.orderStopFlagCurrentFn = this.orderStopFlagModFn;
      this.orderStopFlagCurrentFnUpdated = true;
    } else {
      this.orderStopFlagCurrentFn = this.orderStopFlagFn;
      this.orderStopFlagCurrentFnUpdated = false;
    }
    this.orderStopFlagCurrentFv = this.commonService.getOrderStopFlagName(this.orderStopFlagCurrentFn);
    this.orderStopFlagCurrentFvUpdated = this.orderStopFlagCurrentFnUpdated;
    this.orderBaraNumCurrentFn = this.orderNumCurrentFn * this.orderLotFn || 0;

    this.startDateFdForm.setValue(this.startDateFd);
    this.finishDateFdForm.setValue(this.finishDateFd);
    this.minZaiCurrentFvForm.setValue(this.minZaiCurrentFv);
    this.maxZaiCurrentFvForm.setValue(this.maxZaiCurrentFv);
    this.minStockDaysCurrentFvForm.setValue(this.minStockDaysCurrentFv);
    this.maxStockDaysCurrentFvForm.setValue(this.maxStockDaysCurrentFv);

    this.originDto = { ...itemDto }
  }

  setOrderNum(value: number, version: number): void {
    this.orderNumModFn = value;
    this.orderNumVersionFn = version;
    this.orderNumCurrentFn = value;
    this.orderNumCurrentFnUpdated = true;
    this.orderBaraNumCurrentFn = this.orderNumCurrentFn * this.orderLotFn || 0;
  }

  setStockNum(value: number, version: number): void {
    this.stockNumModFn = value;
    this.stockNumVersionFn = version;
    this.stockNumCurrentFn = value;
    this.stockNumCurrentFnUpdated = true;
  }

  setMinZai(val: number, version: number) {
    if (version > 0) {
      this.minZaiModFn = val;
      this.minZaiVersionFn = version;
      this.minZaiCurrentFv = this.paramCurrent(this.minZaiModFn);
      this.minZaiCurrentFvUpdated = true;
      if (this.minZaiModFn == 0) {
        this.minZaiModIsNull = true;
        this.minZaiCurrentIsNull = true;
      } else {
        this.minZaiModIsNull = false;
        this.minZaiCurrentIsNull = false;
      }
    }
  }

  setMaxZai(val: number, version: number) {
    if (version > 0) {
      this.maxZaiModFn = val;
      this.maxZaiVersionFn = version;
      this.maxZaiCurrentFv = this.paramCurrent(this.maxZaiModFn);
      this.maxZaiCurrentFvUpdated = true;
      if (this.maxZaiModFn == 0) {
        this.maxZaiModIsNull = true;
        this.maxZaiCurrentIsNull = true;
      } else {
        this.maxZaiModIsNull = false;
        this.maxZaiCurrentIsNull = false;
      }
    }
  }

  setMinStockDays(val: number, version: number) {
    if (version > 0) {
      this.minStockDaysModFn = val;
      this.minStockDaysVersionFn = version;
      this.minStockDaysCurrentFv = this.paramCurrent(this.minStockDaysModFn);
      this.minStockDaysCurrentFvUpdated = true;
      if (this.minStockDaysModFn == 0) {
        this.minStockDaysModIsNull = true;
        this.minStockDaysCurrentIsNull = true;
      } else {
        this.minStockDaysModIsNull = false;
        this.minStockDaysCurrentIsNull = false;
      }
    }
  }

  setMaxStockDays(val: number, version: number) {
    if (version > 0) {
      this.maxStockDaysModFn = val;
      this.maxStockDaysVersionFn = version;
      this.maxStockDaysCurrentFv = this.paramCurrent(this.maxStockDaysModFn);
      this.maxStockDaysCurrentFvUpdated = true;
      if (this.maxStockDaysModFn == 0) {
        this.maxStockDaysModIsNull = true;
        this.maxStockDaysCurrentIsNull = true;
      } else {
        this.maxStockDaysModIsNull = false;
        this.maxStockDaysCurrentIsNull = false;
      }
    }
  }

  paramCurrent(val): string {
    return "" + val;
  }

  setOrderStopFlag(val: number, version: number) {
    if (version > 0) {
      this.orderStopFlagModFn = val;
      this.orderStopFlagCurrentFn = val;
      this.orderStopFlagCurrentFv = this.commonService.getOrderStopFlagName(this.orderStopFlagCurrentFn);
      this.orderStopFlagVersionFn = version;
      this.orderStopFlagCurrentFnUpdated = true;
      this.orderStopFlagCurrentFvUpdated = true;
    }
  }

}
